<template>
  <article v-editable="blok" :data-page="state?.page?.slug" :data-redirecting="redirecting" :data-theme="blok.background || 'light'">
    <template v-if="redirectUrl !== null">
      <div v-if="isPreview" class="container py-5">Redirecting to: {{ redirectUrl }}</div>
    </template>
    <template v-else>
      <template v-if="(gated && authenticated) || !gated">
        <StoryblokComponent v-for="sections in blok.body" :key="sections._uid" :blok="sections" />
      </template>
      <template v-else>
        <PageGate @authenticated="onAuthenticated" />
      </template>
    </template>
  </article>
</template>

<script setup>
  const props = defineProps({ blok: Object });
  const route = useRoute();
  const { getRedirect, handleRedirects } = useRedirect();
  const isPreview = useRuntimeConfig().public.NUXT_FORMS_ENV !== "production";
  const state = usePageStore();
  const authenticated = ref(false);
  const allowRedirect = ref(true);
  const redirecting = ref(false);
  const redirectUrl = ref(null);

  const authStore = useAuthStore();

  const gated = computed(() => {
    if (state?.page?.content?.gated && state?.page?.content?.gated !== "disabled") return true;
    return false;
  });

  const onAuthenticated = (status) => {
    authenticated.value = status;
  };

  onMounted(() => {
    if (gated.value && state?.page?.content?.gated === "commercial") {
      if (useState("is-early-access-user", () => false).value) {
        authenticated.value = true;
      }
    }

    if (authStore.isAuthenticated() === true) {
      authenticated.value = true;
    }

    if (Object.keys(route.query || {})?.includes("_storyblok")) {
      authenticated.value = true;
      allowRedirect.value = false;
    }

    redirectUrl.value = getRedirect(props.blok?.redirect);

    if (allowRedirect.value) {
      redirecting.value = handleRedirects(props.blok?.redirect);
    }
  });
</script>
